<nav *transloco="let t" class="navbar fixed-top bg-secondary" [class.opened]="isMenuOpen()">
  <div class="container-fluid">
    <button type="button" [routerLink]="routes.home" class="btn-home">
      <svg width="23" height="27" viewBox="0 0 23 27" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 9.25204L11.1109 0L22.2532 9.25204V27H0V9.25204ZM18.9452 23.7025V10.7853L11.1109 4.31622L3.32906 10.7853V23.7025H18.9452Z"/>
      </svg>
    </button>
    <a class="navbar-brand" [routerLink]="routes.home">
      <svg class="app-logo" width="127" height="30" viewBox="0 0 127 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="tilde"
              d="M69.4561 4.91499C69.8967 8.39999 72.154 10.595 75.5131 10.595C77.692 10.595 79.396 9.65999 80.6887 8.30999L80.6593 9.46999C80.6887 9.75999 80.816 10.08 81.2567 10.08H83.4014C83.8421 10.08 84.0967 9.81999 84.1897 9.40499L85.125 4.91499H80.3508C79.489 5.88499 78.2992 6.56999 76.7764 6.56999C75.4004 6.56999 74.4701 5.92499 73.9707 4.91499H69.4561Z"/>
        <path class="hopla"
              d="M109.598 23.94H112.438C112.879 23.94 113.163 23.68 113.261 23.265L114.965 15.045C115.376 13.045 117.364 11.405 119.381 11.405C121.399 11.405 122.378 12.695 121.874 15.11L120.17 23.265C120.076 23.685 120.263 23.94 120.708 23.94H123.514C123.955 23.94 124.239 23.68 124.332 23.265L126.065 14.82C127.044 10.18 125.027 7.41 120.958 7.41C119.254 7.41 117.516 8.15 116.13 9.44L117.961 0.675C118.054 0.225 117.868 0 117.423 0H114.583C114.171 0 113.887 0.225 113.794 0.675L109.059 23.26C108.966 23.68 109.152 23.935 109.593 23.935M100.98 24.455C102.939 24.455 104.706 23.65 106.283 22.555C106.66 22.295 106.66 21.975 106.503 21.655L105.622 19.595C105.431 19.145 105.025 19.275 104.741 19.465C103.796 20.015 102.782 20.4 101.582 20.4C99.56 20.4 98.1106 19.015 98.1106 16.95C98.1106 14.435 100.29 11.435 103.477 11.435C104.613 11.435 105.436 11.82 106.19 12.4C106.474 12.66 106.787 12.66 107.135 12.27L108.903 10.21C109.216 9.855 109.25 9.535 108.966 9.275C107.86 8.15 106.254 7.405 103.663 7.405C97.9833 7.405 93.9143 12.495 93.9143 17.3C93.9143 21.23 96.6907 24.45 100.98 24.45M58.0619 23.94H60.9019C61.3132 23.94 61.5972 23.68 61.6903 23.265L66.3909 0.675C66.484 0.225 66.2979 0 65.8866 0H63.0466C62.6059 0 62.3219 0.225 62.2289 0.675L57.5282 23.265C57.4352 23.685 57.6212 23.94 58.0619 23.94ZM43.4801 17.08C43.4801 15.05 45.0567 11.44 48.592 11.44C50.6731 11.44 51.8091 12.76 51.8091 14.73C51.8091 16.925 50.1981 20.435 46.7265 20.435C44.7042 20.435 43.4752 19.05 43.4752 17.08M46.888 24.455C53.3564 24.455 56.0348 18.24 56.0348 14.015C56.0348 10.085 53.6697 7.41 50.012 7.41C47.647 7.41 45.8794 8.375 44.5524 9.73V8.445C44.5524 8.06 44.3614 7.865 43.9501 7.865H41.9279C41.5165 7.865 41.2326 8.09 41.1395 8.54L36.7865 29.325C36.6935 29.775 36.8795 30 37.3251 30H40.1651C40.6058 30 40.8898 29.775 40.9877 29.325L42.4371 22.3C43.3185 23.62 44.7727 24.455 46.888 24.455ZM23.5316 16.985C23.5316 14.565 25.5539 11.44 28.8688 11.44C30.9547 11.44 32.3111 12.86 32.3111 14.855C32.3111 17.305 30.3231 20.4 27.0081 20.4C24.8928 20.4 23.5365 19.015 23.5365 16.985M26.5625 24.455C33.4764 24.455 36.5025 18.24 36.5025 14.625C36.5025 10.63 33.5401 7.41 29.3095 7.41C22.8706 7.41 19.3695 13.015 19.3695 17.27C19.3695 21.235 22.3026 24.455 26.5625 24.455ZM0.557072 23.94H3.39706C3.83775 23.94 4.12175 23.68 4.21968 23.265L5.92367 15.045C6.33498 13.045 8.32297 11.405 10.3403 11.405C12.3577 11.405 13.337 12.695 12.8327 15.11L11.1287 23.265C11.0356 23.685 11.2217 23.94 11.6673 23.94H14.473C14.9137 23.94 15.1977 23.68 15.2907 23.265L17.0241 14.82C18.0034 10.18 15.9811 7.41 11.917 7.41C10.213 7.41 8.47476 8.15 7.08904 9.44L8.92035 0.675C9.01338 0.225 8.82731 0 8.38173 0H5.54174C5.13043 0 4.84643 0.225 4.7534 0.675L0.02335 23.265C-0.0696841 23.685 0.116384 23.94 0.561968 23.94M82.6327 13.03C83.1713 13.03 83.2301 13.415 83.1713 13.705L81.0413 23.94H76.2672C77.2612 22.815 77.8047 21.305 77.8047 19.955C77.8047 17.955 76.5757 16.6 74.5877 16.6C70.9594 16.6 69.4757 19.825 69.4757 22.21C69.4757 22.88 69.6471 23.44 69.8919 23.94H65.3773C65.3235 23.53 65.2843 23.11 65.2843 22.665C65.2843 19.02 67.5563 12.58 74.338 12.58C76.5806 12.58 78.1573 13.61 79.0729 15.155L79.734 13.61C79.8907 13.225 80.1747 13.03 80.586 13.03H82.6376M87.0935 24.39C85.8008 24.39 84.9194 23.52 84.9194 22.36C84.9194 20.62 86.3051 19.335 88.1364 19.335C89.4291 19.335 90.3105 20.14 90.3105 21.295C90.3105 23.035 88.9248 24.39 87.0935 24.39Z"/>
      </svg>
      <!--      <span class="slogan d-none d-md-inline">-->
      <!--        – La vitrine de tes loisirs-->
      <!--      </span>-->
    </a>
    <button type="button"
            class="btn-menu"
            [class.opened]="isMenuOpen()"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
            (click)="toggleMenu()">
      @if (isMenuOpen()) {
        <lucide-icon [img]="icons.close" [size]="40"></lucide-icon>
      } @else {
        <lucide-icon [img]="icons.menu" [size]="40"></lucide-icon>
      }

    </button>
    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-body">

        @if (user?.role === userRoles.Moderator) {
          <ul class="nav-menu">
            <li>
              <a [routerLink]="routes.moderate"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas">
                <lucide-icon [img]="icons.admin"></lucide-icon>
                Modération
              </a>
            </li>
          </ul>
        }

        <div>
          <a [routerLink]="user ? routes.publish : routes.publishGuest"
             (click)="hideMenu()"
             data-bs-dismiss="offcanvas"
             class="btn btn-focus btn-block my-1">
            <lucide-icon [img]="icons.publish"></lucide-icon>
            {{ t('layout.menu.Publish') }}
          </a>
        </div>

        @if (user) {

          <div>
            <div class="menu-header">{{ user.userName }}</div>
            @if (user?.state === userStates.Registered) {
              <div class="my-1">
                <a [routerLink]="routes.validateEmail"
                   (click)="hideMenu()"
                   data-bs-dismiss="offcanvas"
                   class="btn btn-block btn-sm btn-warning">
                  <i class="bi bi-exclamation-triangle"></i> je valide mon email
                </a>
              </div>
            }
            <ul class="nav-menu">
              <li>
                <a [routerLink]="routes.dashboard"
                   (click)="hideMenu()"
                   data-bs-dismiss="offcanvas">
                  <lucide-icon [img]="icons.dashboard"></lucide-icon>
                  Tableau de bord
                </a>
              </li>
              <li>
                <a [routerLink]="routes.account"
                   (click)="hideMenu()"
                   data-bs-dismiss="offcanvas">
                  <lucide-icon [img]="icons.account"></lucide-icon>
                  {{ t('layout.menu.Account') }}
                </a>
              </li>

              <li>
                <a (click)="logout()" data-bs-dismiss="offcanvas">
                  <lucide-icon [img]="icons.logout"></lucide-icon>
                  {{ t('layout.menu.Logout') }}
                </a>
              </li>
            </ul>
          </div>

          <div class="mt-2">
            <app-user-membership-selector [user]="user"></app-user-membership-selector>

            <ul class="nav-menu">
              @if (currentMembership()) {
                <li>
                  <a [routerLink]="hostPreviewRoute()"
                     (click)="hideMenu()"
                     data-bs-dismiss="offcanvas">
                    <lucide-icon [img]="icons.host"></lucide-icon>
                    Profil
                  </a>
                </li>
<!--                <li>-->
<!--                  <a [routerLink]="hostActivitiesRoute()"-->
<!--                     (click)="hideMenu()"-->
<!--                     data-bs-dismiss="offcanvas">-->
<!--                    <lucide-icon [img]="icons.activity"></lucide-icon>-->
<!--                    Activités-->
<!--                  </a>-->
<!--                </li>-->
              }
            </ul>
          </div>

        } @else {
          <div class="row gx-0 my-2">
            <div class="col-6 pe-2">
              <a [routerLink]="routes.register"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas"
                 class="btn btn-light btn-block fw-bold">
                {{ t('layout.menu.CreateAccount') }}
              </a>
            </div>
            <div class="col-6 ps-2">
              <a [routerLink]="routes.login"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas"
                 class="btn btn-light btn-block fw-bold">
                <lucide-icon [img]="icons.login" [size]="20"></lucide-icon>
                {{ t('layout.menu.SignIn') }}
              </a>
            </div>
          </div>
        }

        <div class="mt-2">
          <div class="menu-header">Navigation</div>

          <ul class="nav-menu">
            <li>
              <a [routerLink]="routes.home"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas">
                <lucide-icon [img]="icons.search"></lucide-icon>
                Trouver une activité
              </a>
            </li>
            <li>
              <a [routerLink]="routes.about"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas">
                <lucide-icon [img]="icons.about"></lucide-icon>
                {{ t('layout.menu.About') }}
              </a>
            </li>
            <li>
              <a [routerLink]="routes.supportUs"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas">
                <lucide-icon [img]="icons.supportUs"></lucide-icon>
                {{ t('layout.menu.SupportUs') }}
              </a>
            </li>
            <li>
              <a [routerLink]="routes.partners"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas">
                <lucide-icon [img]="icons.partners"></lucide-icon>
                {{ t('layout.menu.Partners') }}
              </a>
            </li>
            <li>
              <a [routerLink]="routes.contact"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas">
                <lucide-icon [img]="icons.contact"></lucide-icon>
                {{ t('layout.menu.Contact') }}
              </a>
            </li>
            <li>
              <a [routerLink]="routes.faq"
                 (click)="hideMenu()"
                 data-bs-dismiss="offcanvas">
                <lucide-icon [img]="icons.faq"></lucide-icon>
                {{ t('layout.menu.FAQ') }}
              </a>
            </li>
          </ul>
        </div>

        @if (availableLangs.length > 1) {
          <div class="d-flex justify-content-between">
            @for (lang of availableLangs; track lang; let isLast = $last) {
              <button type="button"
                      (click)="switchLanguage(lang)"
                      [class.mr-1]="!isLast"
                      [class.btn-active]="activeLang === lang">
                {{ lang }}
              </button>
            }
          </div>
        }
      </div>
      <div class="bottom-links d-flex justify-content-between my-2 mx-2">
        <div class="social-links">
          <a href="https://www.facebook.com/www.hopla.ch" target="_blank">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="30" height="30" rx="5" fill="transparent"/>
              <path d="M25.7651 0H4.21611C3.09182 0 2.02374 0.449719 1.23673 1.23673C0.449719 2.02374 0 3.11056 0 4.21611V25.7651C0 26.8894 0.449719 27.9575 1.23673 28.7445C2.02374 29.5315 3.11056 30 4.21611 30H14.0162V19.0381H10.3061V14.7658H14.0162V11.6177C14.0162 9.8376 14.5034 8.45097 15.4966 7.47658C16.4897 6.48345 17.8201 5.99625 19.5066 5.99625C21.193 5.99625 22.2986 6.05247 22.7858 6.18364V9.98751H20.5372C19.7314 9.98751 19.1693 10.1562 18.8695 10.5122C18.5696 10.8495 18.4197 11.3741 18.4197 12.0675V14.7845H22.6359L22.0737 19.0568H18.4197V30H25.7464C26.8707 30 27.9388 29.5503 28.7258 28.7633C29.5128 27.9763 30 26.8894 30 25.7839V4.21611C30 3.09182 29.5128 2.02374 28.7258 1.23673C27.9388 0.449719 26.852 0 25.7464 0L25.7651 0Z" fill="currentColor"/>
            </svg>
          </a>
          <a href="https://www.linkedin.com/company/hopla-ch" target="_blank" class="mx-1">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="29.9625" height="30" rx="5" fill="transparent"/>
              <path d="M25.749 0H4.21348C3.08988 0 2.02247 0.45 1.23595 1.2375C0.449438 2.025 0 3.1125 0 4.21875V25.7812C0 26.9062 0.449438 27.975 1.23595 28.7625C2.02247 29.55 3.10861 30 4.21348 30H25.749C26.8726 30 27.94 29.55 28.7266 28.7625C29.5131 27.975 29.9625 26.8875 29.9625 25.7812V4.21875C29.9625 3.09375 29.5131 2.025 28.7266 1.2375C27.94 0.45 26.8539 0 25.749 0ZM9.98126 23.9625C9.98126 23.9625 9.92508 24.15 9.83145 24.3C9.68164 24.3937 9.56928 24.45 9.49437 24.45H6.02996C6.02996 24.45 5.84269 24.3937 5.69288 24.3C5.59924 24.15 5.54306 24.0375 5.54306 23.9625V11.7937C5.54306 11.7937 5.59924 11.6062 5.69288 11.4563C5.84269 11.3625 5.95505 11.3063 6.02996 11.3063H9.49437C9.49437 11.3063 9.68164 11.3625 9.83145 11.4563C9.92508 11.6062 9.98126 11.7188 9.98126 11.7937V23.9625ZM9.41947 9.225C9.21347 9.45 8.9513 9.61875 8.65168 9.73125C8.37078 9.84375 8.05242 9.9 7.7528 9.9C7.09737 9.9 6.5543 9.675 6.10486 9.225C5.88014 9.01875 5.7116 8.75625 5.59924 8.475C5.48689 8.19375 5.43071 7.875 5.43071 7.575C5.43071 6.9375 5.65542 6.4125 6.10486 5.9625C6.31085 5.7375 6.57303 5.55 6.85392 5.4375C7.13482 5.30625 7.45317 5.25 7.7528 5.25C8.05242 5.25 8.37078 5.30625 8.65168 5.4375C8.93257 5.56875 9.19475 5.7375 9.40074 5.9625C9.85018 6.4125 10.0749 6.95625 10.0749 7.575C10.0749 8.19375 9.85018 8.775 9.40074 9.24375L9.41947 9.225ZM24.7003 23.9625C24.7003 23.9625 24.7003 24.0938 24.6629 24.15C24.6442 24.2063 24.6067 24.2625 24.5505 24.3C24.5131 24.3375 24.4569 24.375 24.4007 24.4125C24.3445 24.4313 24.2884 24.45 24.2135 24.45H20.6741C20.6741 24.45 20.4869 24.3937 20.3371 24.3C20.2434 24.15 20.1872 24.0375 20.1872 23.9625V16.5375C20.1872 15.9 20.0749 15.4125 19.8502 15.075C19.5693 14.775 19.1198 14.625 18.5019 14.625C17.6966 14.625 17.1161 14.8688 16.779 15.3375C16.4607 15.825 16.2921 16.5 16.2921 17.3813V23.9813C16.2921 23.9813 16.2921 24.1125 16.2547 24.1688C16.2359 24.225 16.1985 24.2812 16.1423 24.3188C16.1048 24.375 16.0487 24.4125 15.9925 24.4312C15.9363 24.45 15.8614 24.4688 15.8052 24.4688H12.3408C12.3408 24.4688 12.1535 24.4125 12.0037 24.3188C11.9101 24.1688 11.8539 24.0562 11.8539 23.9813V11.8125C11.8539 11.8125 11.9101 11.625 12.0037 11.475C12.1535 11.3812 12.2659 11.325 12.3408 11.325H15.6929C15.7865 11.325 15.8989 11.3438 15.9925 11.4C16.0487 11.4187 16.1048 11.5125 16.1423 11.6625V11.85L16.1798 11.925V12.225C17.0037 11.4187 18.146 11.025 19.6067 11.025C21.2359 11.025 22.4906 11.4187 23.3708 12.1875C24.2696 13.0125 24.7191 14.2125 24.7191 15.7687V23.9813L24.7003 23.9625Z" fill="currentColor"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/hopla.ch/" target="_blank">
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="30" height="30" rx="5" fill="transparent"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M26.3348 0C28.3578 0 30 1.64216 30 3.6652V26.3348C30 28.3578 28.3578 30 26.3348 30H3.6652C1.64216 30 0 28.3578 0 26.3348V3.6652C0 1.64216 1.64216 0 3.6652 0H26.3348ZM15 4.74608C12.2152 4.74608 11.8662 4.75784 10.7725 4.80784C9.68088 4.85784 8.93578 5.03088 8.28333 5.28431C7.60882 5.54657 7.03725 5.89706 6.46716 6.46716C5.89706 7.03725 5.54657 7.60931 5.28431 8.28333C5.03088 8.93578 4.85735 9.68088 4.80784 10.7725C4.75784 11.8662 4.74608 12.2152 4.74608 15C4.74608 17.7848 4.75784 18.1338 4.80784 19.2275C4.85784 20.3191 5.03088 21.0642 5.28431 21.7167C5.54657 22.3907 5.89706 22.9627 6.46716 23.5328C7.03725 24.1029 7.60882 24.4534 8.28333 24.7157C8.93578 24.9691 9.68088 25.1426 10.7725 25.1922C11.8662 25.2422 12.2152 25.2539 15 25.2539C17.7848 25.2539 18.1338 25.2422 19.2275 25.1922C20.3191 25.1422 21.0642 24.9691 21.7167 24.7157C22.3907 24.4534 22.9627 24.1029 23.5328 23.5328C24.1029 22.9627 24.4534 22.3907 24.7157 21.7167C24.9691 21.0642 25.1426 20.3191 25.1922 19.2275C25.2422 18.1338 25.2539 17.7848 25.2539 15C25.2539 12.2152 25.2422 11.8662 25.1922 10.7725C25.1422 9.68088 24.9691 8.93578 24.7157 8.28333C24.4534 7.60931 24.1029 7.03725 23.5328 6.46716C22.9627 5.89706 22.3907 5.54657 21.7167 5.28431C21.0642 5.03088 20.3191 4.85735 19.2275 4.80784C18.1338 4.75784 17.7848 4.74608 15 4.74608ZM15 6.59363C17.7377 6.59363 18.0623 6.60392 19.1436 6.65343C20.1431 6.69902 20.6863 6.86618 21.0475 7.00637C21.526 7.19265 21.8676 7.41471 22.2265 7.77353C22.5853 8.13235 22.8074 8.47402 22.9936 8.95245C23.1338 9.31373 23.301 9.85686 23.3466 10.8564C23.3961 11.9377 23.4064 12.2618 23.4064 15C23.4064 17.7382 23.3961 18.0623 23.3466 19.1436C23.301 20.1431 23.1338 20.6863 22.9936 21.0475C22.8074 21.526 22.5853 21.8676 22.2265 22.2265C21.8676 22.5853 21.526 22.8074 21.0475 22.9936C20.6863 23.1338 20.1431 23.301 19.1436 23.3466C18.0627 23.3961 17.7382 23.4064 15 23.4064C12.2618 23.4064 11.9377 23.3961 10.8564 23.3466C9.85686 23.301 9.31373 23.1338 8.95245 22.9936C8.47402 22.8074 8.13235 22.5853 7.77353 22.2265C7.41471 21.8676 7.19265 21.526 7.00637 21.0475C6.86618 20.6863 6.69902 20.1431 6.65343 19.1436C6.60392 18.0623 6.59363 17.7382 6.59363 15C6.59363 12.2618 6.60392 11.9377 6.65343 10.8564C6.69902 9.85686 6.86618 9.31373 7.00637 8.95245C7.19216 8.47402 7.41471 8.13235 7.77353 7.77353C8.13235 7.41471 8.47402 7.19265 8.95245 7.00637C9.31373 6.86618 9.85686 6.69902 10.8564 6.65343C11.9377 6.60392 12.2618 6.59363 15 6.59363ZM15 9.73431C12.0922 9.73431 9.73431 12.0917 9.73431 15C9.73431 17.9083 12.0917 20.2657 15 20.2657C17.9083 20.2657 20.2657 17.9083 20.2657 15C20.2657 12.0917 17.9083 9.73431 15 9.73431ZM15 18.4181C13.1123 18.4181 11.5819 16.8877 11.5819 15C11.5819 13.1123 13.1123 11.5819 15 11.5819C16.8877 11.5819 18.4181 13.1123 18.4181 15C18.4181 16.8877 16.8877 18.4181 15 18.4181ZM21.7039 9.52647C21.7039 10.2059 21.1529 10.7569 20.4735 10.7569C19.7941 10.7569 19.2431 10.2059 19.2431 9.52647C19.2431 8.84706 19.7941 8.29608 20.4735 8.29608C21.1529 8.29608 21.7039 8.84706 21.7039 9.52647Z" fill="currentColor"/>
            </svg>
          </a>
        </div>
        <div class="terms">
          <a [routerLink]="routes.terms"
             (click)="hideMenu()"
             data-bs-dismiss="offcanvas">
            {{ t('layout.menu.Terms') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</nav>
<div class="nav-placeholder"></div>
<div class="route-content">
  <router-outlet>
  </router-outlet>
</div>
